import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../../redux/action';
import { withRouter } from 'react-router-dom';
import ResendModalSC from './resend-modal.styled';
import { HeadingTwo, BodyText, SmallText } from '../../typography';
import { ReactComponent as CheckCircle } from '../../../assets/img/svg/success-check.svg';
import dlt from '../../../utils/default-lang';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import ResendForm from '../resend-form';

const _ResendModal = ({ resendPassword }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setIsSuccess(false);
    setIsError(false);
  }, []);

  const onSubmitForm = (values) => {
    const dataToSend = {
      id: values.id,
    };

    const onBadId = () => {
      setIsError(true);
      setIsLoading(false);
    };

    const onSuccess = () => {
      setIsSuccess(true);
      setIsLoading(false);
    };

    const sendModalData = async () => {
      setIsLoading(true);
      await resendPassword({ data: dataToSend, onSuccess, onBadId });
    };

    sendModalData();
  };

  return (
    <ResendModalSC>
      {isSuccess ? (
        <div className="is-success">
          <div className="img-wrap">
            <CheckCircle />
          </div>
          <BodyText className="bolder">
            <FormattedMessage
              id="login_resend_form_success"
              defaultMessage={dlt['login_resend_form_success']}
            />
          </BodyText>
        </div>
      ) : (
        <>
          <div className="top-text-wrap">
            <HeadingTwo className="bold">
              <FormattedMessage
                id="login_resend_form_headline"
                defaultMessage={dlt['login_resend_form_headline']}
              />
            </HeadingTwo>
            <SmallText className="bolder black-transparent">
              <FormattedHTMLMessage
                id="login_resend_form_subtext"
                defaultMessage={dlt['login_resend_form_subtext']}
              />
            </SmallText>
          </div>
          <ResendForm onSubmitForm={(values) => onSubmitForm(values)} isLoading={isLoading} />
          {isError ? (
            <div className="is-error">
              <BodyText className="bolder red">
                <FormattedMessage
                  id="login_resend_form_error"
                  defaultMessage={dlt['login_resend_form_error']}
                />
              </BodyText>
            </div>
          ) : null}
        </>
      )}
    </ResendModalSC>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      resendPassword: ActionCreators.resendPassword,
    },
    dispatch
  );
};

const ResendModal = withRouter(connect(null, mapDispatchToProps)(_ResendModal));

export default ResendModal;
